import Cookies from "js-cookie";
import StudentDashboardServices from "../Services/StudentDashboardApiService";
import RoutesPath from "./RoutesPath";
import { handleApiErrors } from "./Utils";
import CoordinatorApiServices from "../Services/CoordinatorApiServices";

const SESSION_TOKEN = "SessionToken1";
const COORDINATOR_TOKEN = "SessionToken2";
const FORGOT_PASSWORD_TOKEN = "ForgotPasswordToken";
const USER_DATA = "UserData1";
const COORDINATOR_DATA = "CoordinatorData";
const COOKIE_EXPIRY = 1; // In Days

class SessionManager {
    static shared = new SessionManager();
    tokenListener = [];
    dataListener = [];

    getData = async () => {
        try {
            const response = await StudentDashboardServices.getDetails();
            if (response) {
                this.storeUserData(response.user);
            }
        } catch (error) {
            handleApiErrors(error);
        }
    };
    getCoordinatorData = async () => {
        try {
            const response = await CoordinatorApiServices.getCoordinatorDetails();
            if (response) {
                this.storeCoordinatorData(response.coordinator);
            }
        } catch (error) {
            handleApiErrors(error);
        }
    };

    setSessionToken(token) {
        Cookies.set(SESSION_TOKEN, token, { expires: COOKIE_EXPIRY });
        this.notifyTokenListeners();
    }
    setCoordinatorSessionToken(token) {
        Cookies.set(COORDINATOR_TOKEN, token, { expires: COOKIE_EXPIRY });
        this.notifyTokenListeners();
    }

    setForgotPasswordToken(token) {
        localStorage.setItem(FORGOT_PASSWORD_TOKEN, token);
    }

    getForgotPasswordToken() {
        return localStorage.getItem(FORGOT_PASSWORD_TOKEN);
    }

    storeUserData(user) {
        Cookies.set(USER_DATA, JSON.stringify(user), { expires: COOKIE_EXPIRY });
        this.notifyDataListeners();
    }

    storeCoordinatorData(coordinator) {
        Cookies.set(COORDINATOR_DATA, JSON.stringify(coordinator), { expires: COOKIE_EXPIRY });
        this.notifyDataListeners();
    }

    getSessionToken() {
        return Cookies.get(SESSION_TOKEN);
    }
    getCoordinatorToken() {
        return Cookies.get(COORDINATOR_TOKEN);
    }
    deleteCoordinatorToken() {
        Cookies.remove(COORDINATOR_TOKEN);
        Cookies.remove(COORDINATOR_DATA);
    }
    deleteStudentToken() {
        Cookies.remove(SESSION_TOKEN);
        Cookies.remove(USER_DATA);
    }

    retrieveUserData() {
        const userData = Cookies.get(USER_DATA);
        return userData ? JSON.parse(userData) : null;
    }
    retrieveCoordinatorData() {
        const coordinatordata = Cookies.get(COORDINATOR_DATA);
        return coordinatordata ? JSON.parse(coordinatordata) : null;
    }

    logout(shouldNavigate = true) {
        Cookies.remove(SESSION_TOKEN);
        Cookies.remove(USER_DATA);
        localStorage.removeItem("bhasdlfa");
        this.notifyTokenListeners();
        this.notifyDataListeners();
        if (shouldNavigate)
        window.location.href = RoutesPath.home;
    }
    logoutCoordinator() {
        Cookies.remove(COORDINATOR_TOKEN);
        Cookies.remove(COORDINATOR_DATA);
        this.notifyTokenListeners();
        this.notifyDataListeners();
        window.location.href = RoutesPath.home;
    }

    // Subscribe a listener to session changes
    subscribeData(listener) {
        this.dataListener?.push(listener);
    }

    // Subscribe a listener to session changes
    subscribeToken(listener) {
        this.tokenListener?.push(listener);
    }

    // Unsubscribe a listener from session changes
    unsubscribeData(listener) {
        this.listeners = this.listeners?.filter((l) => l !== listener);
    }

    // Unsubscribe a listener from session changes
    unsubscribeToken(listener) {
        this.tokenListener = this.tokenListener?.filter((l) => l !== listener);
    }

    // Notify all listeners of session changes
    notifyDataListeners() {
        this.dataListener?.forEach((listener) => listener());
    }

    // Notify all listeners of session changes
    notifyTokenListeners() {
        this.tokenListener?.forEach((listener) => listener());
    }
}

export default SessionManager;
